import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/favicon.png?v=2'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"max-width":"31%"},
  alt: "logo-icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10" }, "Mokapp", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<li class=\"sidebar-nav-item accordion-item bg-transparent border-0 rounded-0\"><a href=\"/dashboard\" class=\"accordion-button rounded-0 shadow-none bg-transparent d-block\" data-bs-toggle=\"collapse\" data-bs-target=\"#sidebarCollapseOne\" aria-expanded=\"true\" aria-controls=\"sidebarCollapseOne\"><i class=\"flaticon-more-1\"></i><span class=\"title\">Dashboard</span></a><div id=\"sidebarCollapseOne\" class=\"accordion-collapse collapse show\" data-bs-parent=\"#sidebarNavAccordion\"><div class=\"accordion-body\"><ul class=\"sidebar-sub-menu ps-0 mb-0 list-unstyled\"><li class=\"sidebar-sub-menu-item\"><a href=\"/counter-movement-jumps\" class=\"sidebar-sub-menu-link\">Salto com contramovimento</a></li></ul></div></div></li>", 1)
const _hoisted_10 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-users-group" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pacientes", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  id: "sidebarCollapseSeven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_15 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PatientsMenu = _resolveComponent("PatientsMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", {
            href: "#",
            class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#sidebarCollapseSeven",
            "aria-expanded": "false",
            "aria-controls": "sidebarCollapseSeven",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeHighlightClass()))
          }, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_PatientsMenu)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}